/**
 * Tiny module-level holder for the current owner/manager session token. A login
 * flow writes it; the API client reads it to attach `Authorization: Bearer <token>`.
 * The backend NEVER trusts client identity — it verifies this token server-side.
 */
export const OWNER_SESSION_TOKEN_KEY = "jod.owner.token";

let currentToken: string | undefined;

export function setAuthToken(token: string | undefined): void {
  currentToken = token;
}

/** Read the in-memory token, hydrating from sessionStorage when needed (e.g. refresh). */
export function getAuthToken(): string | undefined {
  if (currentToken) return currentToken;
  if (typeof window === "undefined") return undefined;
  const stored = window.sessionStorage.getItem(OWNER_SESSION_TOKEN_KEY);
  if (stored) {
    currentToken = stored;
    return stored;
  }
  return undefined;
}
